<template>
    <tailwind-layout title="User Income Verification">
        <template #header>
            <div class="px-4 sm:px-6 lg:px-8 mx-auto hidden lg:flex justify-between items-center"><!-- Block for lg and larger -->
                <div class="flex flex-col">
                    <h1 class="font-semibold text-2xl leading-tight">User Income Verification</h1>
                    <h2 class="text-xs">To proceed with income verification, please provide one of the following.</h2>
                </div>
                <div class="flex items-center space-x-4">
                    <inertia-link class="whiteButton" :href="route('application.steps', application.id)">
                        <FontAwesome :icon="faChevronLeft" class="h-5 w-5 text-gray-400" aria-hidden="true" /> Back
                    </inertia-link>
                </div>
            </div>

            <div class="mb-3 px-6 lg:px-8 mx-auto flex flex-col lg:hidden"><!-- Block for sm, md, lg (buttons will stack on smaller screens) -->
                <div class="flex justify-between items-start md:items-center">
                    <div class="flex flex-col">
                        <h1 class="font-semibold text-2xl leading-tight">User Income Verification</h1>
                        <h2 class="text-xs">To proceed with income verification, please provide one of the following.</h2>
                    </div>
                    <inertia-link class="whiteButton" :href="route('application.steps', application.id)">
                        <FontAwesome :icon="faChevronLeft" class="h-5 w-5 text-gray-400" aria-hidden="true" /> Back
                    </inertia-link>
                </div>
            </div>
        </template>

        <div class="rounded-md lg:shadow shadow-none overflow-x-auto">
                <div class="flex flex-col">
                    <div class="overflow-x-auto">
                        <div class="align-middle inline-block min-w-full">
                            <div class="shadow overflow-hidden lg:border">
                                <table class="min-w-full divide-y divide-gray-300">
                                    <thead class="bg-blue-50">
                                    <tr>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">
                                            Type
                                        </th>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">
                                            Status
                                        </th>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="bg-gray-50 border-b hover:bg-yellow-50 hover:cursor-pointer">
                                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                                Bank Income Verification
                                            </td>
                                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                                {{incomes['bank_income'] ? 'Added' : 'Not Added'}}
                                            </td>
                                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                                <button v-if="!incomes['bank_income']"
                                                    @click="createLinkToken('bank')"
                                                    class="text-blue-600">
                                                    Add
                                                </button>
                                                <a
                                                    v-if="incomes['bank_income']"
                                                    target="_blank"
                                                    :href="route('user-bank-income.load', application.id)"
                                                    class="text-blue-600">
                                                    View
                                                </a>
                                            </td>
                                        </tr>
                                        <!-- removing payroll/document income for now -->
                                        <!-- <tr class="bg-gray-50 border-b hover:bg-yellow-50 hover:cursor-pointer">
                                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                                Payroll/Document Income Verification
                                            </td>
                                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                                {{incomes['payroll'] ? 'Added' : 'Not Added'}}
                                            </td>
                                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                                <button
                                                    v-if="!incomes['payroll']"
                                                    @click="createLinkToken('payroll')"
                                                    class="text-blue-600">
                                                    Add
                                                </button>
                                                <InertiaLink
                                                    v-if="incomes['payroll']"
                                                    :href="route('user-payroll-income.load', application.id)"
                                                    class="text-blue-600">
                                                    View
                                                </InertiaLink>
                                            </td>
                                        </tr> -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <full-page-loader v-if="isLoader"></full-page-loader>
    </tailwind-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination.vue'
import pickBy from 'lodash/pickBy'
import { usePage, router } from '@inertiajs/vue3'
import axios from "axios";
import FullPageLoader from "@/Shared/FullPageLoader.vue";
import NavLink from "@/Jetstream/NavLink.vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons'

export default {
    components: {
        NavLink,
        FullPageLoader,
        Icon,
        Pagination,
        TailwindLayout,
        FontAwesome: FontAwesomeIcon
    },
    props: {
        application: Object,
        addon_id: Number,
        incomes: Array,
    },
    data() {
        return {
            isLoader: false,
            faChevronLeft,
        }
    },
    watch: {

    },
    mounted() {
        // CSRF handling is now managed globally via axios defaults and XSRF cookies
    },
    methods: {
        async createLinkToken(income_source_type) {
            this.isLoader = true;
            try {
                // Ensure CSRF cookie exists immediately before posting
                await axios.get('/sanctum/csrf-cookie');
                if (income_source_type === 'bank') {
                    const response = await axios.post(route('user-bank-income.create-link-token'), {
                        income_source_type: income_source_type,
                    });

                    if (response.data.status) {
                        this.initializePlaidLink(response.data.public_token, income_source_type);
                    }
                }
                else if (income_source_type === 'payroll') {
                    const response = await axios.post(route('user-document-income.create-link-token'), {
                        income_source_type: income_source_type,
                    });

                    if (response.data.status) {
                        this.initializePlaidLink(response.data.public_token, income_source_type);
                    }
                }

                // Handle the successful response here
            } catch (error) {
                // Handle any errors here
                console.error('Error:', error.response ? error.response.data : error.message);
            }
        },

        async initializePlaidLink(public_token, income_source_type) {
            this.isLoader = false;
            var handler = Plaid.create({
                token: public_token,  // Use the provided public token directly
                onLoad: function () {
                    // Optional, called when Link loads
                },
                onSuccess: (token, metadata) => {
                    this.isLoader = true;
                    if (income_source_type === 'bank') {
                        this.finishBankIncome(public_token, metadata);
                    } else if (income_source_type === 'payroll') {
                        this.finishPayrollIncome(public_token, metadata);
                    }
                },
                onExit: function (err, metadata) {
                    this.isLoader = true;
                    // The user exited the Link flow.
                    if (err != null) {
                        // The user encountered a Plaid API error prior to exiting.
                    }
                    // metadata contains information about the institution
                    // that the user selected and the most recent API request IDs.
                    // Storing this information can be helpful for support.
                },
                onEvent: function (eventName, metadata) {
                    // Optionally capture Link flow events, streamed through
                    // this callback as your users connect an Item to Plaid.
                    // For example:
                    // eventName = "TRANSITION_VIEW"
                    // metadata  = {
                    //   link_session_id: "123-abc",
                    //   mfa_type:        "questions",
                    //   timestamp:       "2017-09-14T14:42:19.350Z",
                    //   view_name:       "MFA",
                    // }
                }
            });

            handler.open();
        },

        async finishBankIncome(public_token, metadata) {
            const response = await axios.post(route('user-bank-income.save'), {
                type: 'bank_income',
                public_token: public_token,
                metadata: metadata,
                application_id: this.application.id,
                addon_id: this.addon_id,
            });
            this.isLoader = false;
            router.reload();
        },

        async finishPayrollIncome(public_token, metadata) {
            const response = await axios.post(route('user-payroll-income.save'), {
                type: 'payroll',
                public_token: public_token,
                metadata: metadata,
                application_id: this.application.id,
                addon_id: this.addon_id,
            });
            this.isLoader = false;
            router.reload();
        },

    },
}
</script>
